import { getAwsAssets } from "@src/utils/index";
import { Image } from "@src/components/Image";
import React from "react";
import styles from "../../styles/NoContentScreen.module.scss";

const NoContentScreen = ({ noContentText, subtext, height }) => {
  return (
    <div
      className={styles.noContentScreen}
      style={height ? { height: height } : {}}
    >
      <Image
        src={getAwsAssets("booksStacked.svg", "content")}
        alt="noContentScreenThumbnail"
        height={140}
        width={140}
      />
      <h4>{noContentText}</h4>
      <p>{subtext}</p>
    </div>
  );
};

export default NoContentScreen;
